import { ChevronDown } from "lucide-react";
import React from "react";

import { Autocomplete, AutocompleteProps } from "@mui/material";

export const IgAutocomplete = (
  props: AutocompleteProps<any, any, any, any>
) => {
  return (
    <Autocomplete
      {...props}
      popupIcon={props.popupIcon ?? <ChevronDown size={16} />}
    />
  );
};
